import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigModule, I18nConfig, provideConfig, RoutingConfig } from '@spartacus/core';
import { UigActiveCartService } from './uig-active-cart.service';
import { customErrorHandlers, customHttpErrorInterceptors } from './http-interceptors';
import {ActiveCartFacade} from '@spartacus/cart/base/root';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      
    } as RoutingConfig),
  ],
  providers: [
     { provide: ActiveCartFacade, useClass: UigActiveCartService },
    [...customErrorHandlers, ...customHttpErrorInterceptors],
    provideConfig(<I18nConfig>{
      i18n: {
        chunks: { uigProduct: ['uigAddToCart'] },
      }
    })
  ]
})
export class ServicesModule { }
